import { Col, Row } from "antd";
import { useParams } from "react-router";
import PackagingList from "./packagingList";
import { useState } from "react";
import { useMutation, useQuery } from "react-query";
import { getItemsId } from "../../../api/itemapi";
import AddButton from "../../UI/AddButton/addbutton";
import ResetButton from "../../UI/ResetButton/resetbutton";
import { AddEditPackaging } from "./AddEditPackaging";
import { Search } from "../../UI/Search/Search";
import { FilterInput } from "../../UI/FilterApi/filterapi";
import { getItemUnitDropdown } from "../../../api/itemUnit";

type prop = {
  category: any;
};

const Packaging = ({ category }: prop) => {
  const { id } = useParams();
  const [search, setSearch] = useState<string>("");
  const [filter, setFilter] = useState<boolean | undefined>(undefined);
  const [paginatedItemPackaging, setPaginatedItemPackaging] = useState<any>();
  const [tableKey, setTableKey] = useState("");
  const [openPackaging, setOpenPackaging] = useState(false);
  const [, setInitialValues] = useState({ isActive: undefined });

  const getPackaging = async (params: {
    itemsId: string | undefined;
    q: string;
    isActive?: boolean;
  }) => {
    // Make your API request here using the updated parameters
    return await ItemPackagingMutation(params);
  };

  const {
    mutateAsync: ItemPackagingMutation,
    isLoading: isItemPackagingLoading,
  } = useMutation("items", getItemsId);

  const resetFilters = () => {
    getPackaging({
      itemsId: id,
      q: "",
    }).then((res) => {
      setPaginatedItemPackaging(res.data?.childrenItems);
      setSearch("");
      setFilter(undefined);
      setTableKey((tableKey) => tableKey + 1);
    });
  };

  const handleSearch = () => {
    getPackaging({
      itemsId: id,
      q: search,
      isActive: filter,
    }).then((res: any) => {
      setPaginatedItemPackaging(res.data?.childrenItems);
    });
  };

  const handleFilter = (value: boolean | undefined) => {
    setFilter(value);
    const isActive = value === undefined ? undefined : value;
    getPackaging({
      itemsId: id,
      q: "",
      isActive: isActive,
    }).then((res: any) => {
      setPaginatedItemPackaging(res.data?.childrenItems);
    });
  };

  const [formatedItemUnit, setFormatedItemUnit] = useState<{}[]>();
  const { isLoading: loadingItemUnit } = useQuery(
    "ItemUnit",
    getItemUnitDropdown,
    {
      refetchOnWindowFocus: false,
      onSuccess: (res) => {
        setFormatedItemUnit(
          res.data
            ?.map((unit: any) => {
              if (unit.isActive) {
                return { value: unit.id, label: unit.name };
              } else {
                return null;
              }
            })
            .filter((unit: any) => unit !== null)
        );
        if (res.data.length > 0) {
          setInitialValues({ isActive: res.data[0].id });
        }
      },
    }
  );

  return (
    <>
      <Row gutter={[10, 10]} style={{ width: "100%" }}>
        <Col span={4}>
          <Search
            value={search}
            onKeyPress={(e: any) => e.code === "Enter" && handleSearch()}
            onChange={(e: any) => setSearch(e.target.value)}
            onEnter={() => {
              handleSearch();
            }}
          />
        </Col>
        <Col span={2}>
          <FilterInput
            key={tableKey}
            onChange={(value: boolean | undefined) => handleFilter(value)}
            value={filter}
          />
        </Col>
        <Col
          offset={14}
          span={4}
          style={{ display: "flex", justifyContent: "flex-end", gap: "20px" }}
        >
          <Col>
            <ResetButton
              onClick={() => {
                resetFilters();
              }}
            />
          </Col>
          <AddButton onClick={() => setOpenPackaging(true)} />
        </Col>
        <Col span={24}>
          <PackagingList
            ItemPackagingMutation={ItemPackagingMutation}
            filter={filter}
            search={search}
            ItemId={id}
            paginatedItemPackaging={paginatedItemPackaging}
            setPaginatedItemPackaging={setPaginatedItemPackaging}
            isItemPackagingLoading={isItemPackagingLoading}
            category={category}
          />
        </Col>
      </Row>
      {openPackaging && (
        <AddEditPackaging
          itemid={id}
          openPackaging={openPackaging}
          formatedItemUnit={formatedItemUnit}
          loadingItemUnit={loadingItemUnit}
          categoryId={category.category?.id}
          type={category.type?.id}
          setOpenPackaging={setOpenPackaging}
          setPaginatedItemPackaging={setPaginatedItemPackaging}
          ItemPackagingMutation={ItemPackagingMutation}
          search={search}
        />
      )}
    </>
  );
};

export default Packaging;
